import axios from 'axios';
import store from '../store';
import { NotificationObject } from '../models/NotificationObject';
import _ from 'lodash';
import { ApiMigrationService } from './ApiMigrationService';

export class NotificationService {
  static allNotifications: NotificationObject[];
  static unreadCount: number;
  static filterMentions: boolean = true;
  static socket: any;

  static async init() {
    try {
      const socketConnectionStatus = _.get(NotificationService.socket,'connected', false);
      if(!socketConnectionStatus) {
        const io = require('socket.io-client');
        NotificationService.socket = io.connect('/', { reconnect: true, path: '/api/socket.io' });
        NotificationService.socket.on('connect', function() {
          // eslint-disable-next-line
          console.log('Connected!');
        });
        NotificationService.socket.on('disconnect', function() {
          // eslint-disable-next-line
          console.log('Disconnected!');
        });
      
        NotificationService.socket.on('addNotification', function(notification: any) {
          NotificationService.allNotifications.push(notification);
          store.commit('updateSingleNotification', notification);
          store.commit('setSnackbar', { serverMessage: `${notification.createdBy.displayName} ${notification.title}`, show: true, color: 'secondary' });
        });
      } else {
        // eslint-disable-next-line
        console.log('socket already connected:', socketConnectionStatus);
      }
    } catch (error) {
      store.commit('setSnackbar', { serverMessage: 'error in initializing socket notifications', show: true, color: 'error' })
    }
    NotificationService.filterMentions = true;
    await NotificationService.getCurrentNotifications();
  }

  static async getCurrentNotifications() {
    try {  
      const originalUrl = '/api/v1/notifications?page=1&limit=20';
      const { resolvedUrl, transformResponse } = ApiMigrationService.getRoutedApi(originalUrl, null);
      const notificationsResponse = await axios.get(
        resolvedUrl,
        { params: { filterMentions: NotificationService.filterMentions } }
      );
      let apiResponse = notificationsResponse.data;
      // Apply V3 to V1 transformation
      if (transformResponse) {
        apiResponse = transformResponse(apiResponse);
      }
      NotificationService.allNotifications = _.get(apiResponse, 'data.docs', []);
      store.commit('setNotifications', {
        allNotifications: NotificationService.allNotifications,
      });
      NotificationService.unreadCount = _.get(apiResponse, 'data.unreadNotificationsCount', []);
      store.commit('setUnreadNotificationCount', NotificationService.unreadCount);
    } catch (error) {
      store.commit('setSnackbar', { serverMessage: 'error in getting current notifications', show: true, color: 'error' })
    }
  }

  static async markNotificationAsRead(notificationId: number, skipRefresh: boolean = false) {
    try {
      const originalUrl = `/api/v1/notifications/${notificationId}/markRead`;
      const { resolvedUrl } = ApiMigrationService.getRoutedApi(originalUrl, null);
      await axios.patch(resolvedUrl);
      if(!skipRefresh) await NotificationService.getCurrentNotifications();
    } catch (error) {
      store.commit('setSnackbar', { serverMessage: 'error in marking as read', show: true, color: 'error' })
    }
  }

  static async markNotificationAsUnread(notificationId: number) {
    try {
      const originalUrl = `/api/v1/notifications/${notificationId}/markUnread`;
      const { resolvedUrl } = ApiMigrationService.getRoutedApi(originalUrl, null);
      await axios.patch(resolvedUrl);
      await NotificationService.getCurrentNotifications();
    } catch (error) {
      store.commit('setSnackbar', { serverMessage: 'error in marking as unread', show: true, color: 'error' })
    }
  }

  static async markAllNotificationAsRead() {
    try {
      const originalUrl = '/api/v1/notifications/markAllRead';
      const { resolvedUrl } = ApiMigrationService.getRoutedApi(originalUrl, null);
      await axios.patch(resolvedUrl);
      await NotificationService.getCurrentNotifications();
    } catch (error) {
      store.commit('setSnackbar', { serverMessage: 'error in marking as unread', show: true, color: 'error' })
    }
  }
}